// Hooks
import { useMenu } from '@/utils/hooks/menu/useMenu';

// Animations
import type { MenuEntriesProps } from '@/components/layouts/LayoutPlatform/components/Menu/components/MenuEntries';
// Components
import { MenuEntries } from '@/components/layouts/LayoutPlatform/components/Menu/components/MenuEntries';

type BottomEntriesProps = OptionalFor<Omit<MenuEntriesProps, 'menuConfig'>, 'isMenuOpen'>;

export function BottomEntries({
    openDropdown,
    stickyMenu,
    setOpenDropdown,
    isMenuOpen = true
}: BottomEntriesProps) {
    const { bottomMenu } = useMenu();
    return (
        <MenuEntries
            menuConfig={bottomMenu}
            stickyMenu={stickyMenu}
            openDropdown={openDropdown}
            setOpenDropdown={setOpenDropdown}
            isMenuOpen={isMenuOpen}
        />
    );
}
